/**
 * Imports jQuery.
 *
 * @see http://api.jquery.com/
 *
 * @since 1.0.0
 */
import $ from 'jquery';

/* eslint-disable */
/**
 * Ajax sorting for Event archives.
 *
 * @since 1.0.0
 */
$( document ).on(
	"change",
	"#event-select",
	function () {
		const eventURL  = $( this ).val();
		window.location = eventURL;
	}
);
